import { useQuery } from "react-query";
import { getOfficeApplianceByOfficeId } from "../api/officeApplianceService";

export const useGetOfficeApplianceByOfficeId = (officeId) => {
  return useQuery(
    ["OfficeApplianceByOfficeId", officeId],
    () => getOfficeApplianceByOfficeId(officeId),
    { refetchOnWindowFocus: false }
  );
};
